import script from "./CircularProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CircularProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./CircularProgressBar.vue?vue&type=style&index=0&id=4a90bc29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a90bc29"]])

export default __exports__